import { HttpClient } from '@angular/common/http';

import { Store } from '@ngrx/store';

import { WINDOW } from '@services/window';

import { FiltersService } from './filters';
import { ErrorHandlerService, HelperService } from './helper';
import { HttpCancelService } from './http-client';
import { CustomHttpClient, opraHttpFactory } from './http-client/http-client.service';
import { PortalHttpClient, portalHttpFactory } from './http-client/portal-http-client.service';
import { LocalStorageService } from './local-storage/local-storage.service';
import { LoginService } from './login';
import { OpraDataService } from './opra-data/opra.data-service';
import { PostMessageService } from './post-message';
import { OpraSessionService, PermissionService, TokenSessionService } from './session';
import { SharedService } from './shared-service';
import { SidebarService } from './sidebar';

export const UTILITY_SERVICES: any[] = [
    OpraDataService,
    OpraSessionService,
    PermissionService,
    LocalStorageService,
    TokenSessionService,
    LoginService,
    SidebarService,
    FiltersService,
    HelperService,
    ErrorHandlerService,
    SharedService,
    PostMessageService,
    HttpCancelService,
    {
        provide: CustomHttpClient,
        useFactory: opraHttpFactory,
        deps: [HttpClient, Store, WINDOW, HttpCancelService],
    },
    {
        provide: PortalHttpClient,
        useFactory: portalHttpFactory,
        deps: [HttpClient, HttpCancelService],
    },
];
